/**
 * Converts a camelCase or PascalCase group name into a human-readable label.
 *
 * @param {string} groupName - The internal group identifier to convert.
 * @returns {string} A user-friendly label for display.
 */
export function defaultGroupLabelProvider(groupName) {
    if (groupName === 'formUs') {
        return 'Form (US Specific)';
    }
    const label = groupName.replace(/([A-Z])/g, ' $1');
    return label.substring(0, 1).toUpperCase() + label.substring(1);
}
